// extracted by mini-css-extract-plugin
module.exports = {"selector":"E7AQJM","categoryPage":"fkjFDo","sortWrapper":"c6uO14","floatingSortWrapper":"xtwQ8p"};